<template lang="pug">
  div
    v-btn(
      v-if="status"
      fab
      depressed
      color="success"
    ).status-btn
      v-icon(small).d-flex mdi-check
    v-btn(
      v-else
      fab
      depressed
      color="error"
    ).status-btn
      v-icon(small).d-flex mdi-close
</template>
<script>
export default {
  props: {
    status: Boolean
  }
}
</script>
<style lang="scss" scoped>
.status-btn::v-deep {
  width: 20px;
  height: 20px;
  cursor: default;
  .v-btn__content {
    height: 20px;
  }
}
</style>